import { SourcingChannelStatus } from 'api-clients/monolith';
import { Loader2 } from 'lucide-react';

import { SetReachPublisherStatus } from '@/components/pages/channels/campaigns/use-reach-channels';
import { CheckCircleIcon } from '@/components/icons/check-circle';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { useToggleCampaign } from '@/hooks/use-toggle-campaign';

interface ToggleCampaignProps {
  sourcingPurchaseId: string;
  reachCampaignId: string | null;
  status: SourcingChannelStatus;
  channel: string;
  setReachPublisherStatus?: SetReachPublisherStatus;
  isDisabled?: boolean;
  openingName?: string;
  openingId?: string;
  startDate?: string | null;
  endDate?: string | null;
  budget?: number | null;
  spent?: number | null;
}

export function ToggleCampaign({
  sourcingPurchaseId,
  reachCampaignId,
  status,
  channel,
  setReachPublisherStatus,
  isDisabled,
  openingName,
  openingId,
  startDate,
  endDate,
  budget,
  spent,
}: ToggleCampaignProps) {
  const { handleToggle, isPending, isCampaignActive, isPool } =
    useToggleCampaign({
      sourcingPurchaseId,
      reachCampaignId,
      status,
      channel,
      setReachPublisherStatus,
      openingName,
      openingId,
      startDate,
      endDate,
      budget,
      spent,
    });

  if (isPending) {
    return <Loader2 className="text-fx-primary h-4 animate-spin" />;
  }

  if (isPool)
    return (
      <Button
        variant="icon"
        size="icon"
        className="border-fx-neutral-300 border"
        onClick={handleToggle}
        disabled={status !== 'active'} // Only allow completion of active pool campaigns. Disallow activation of pool campaigns.
      >
        <CheckCircleIcon />
      </Button>
    );

  return (
    <>
      <Switch
        checked={isCampaignActive}
        onCheckedChange={handleToggle}
        disabled={isDisabled}
      />
    </>
  );
}
